import React, { useState, useEffect } from 'react';
import '../../urunDiv.css';
import '../icecekler/sicak-kahveler/KahveDetay.css';
import ciftKofteTekLezzet from '../../../assets/menu/yemekler/hamburgerler/cift-kofte-tek-lezzet.png';

const CiftKofteTekLezzet = () => {
  const [isPhone, setIsPhone] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsPhone(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const yemek = {
    name: 'Çift Köfte Tek Lezzet',
    price: '₺749,90',
    image: ciftKofteTekLezzet,
    description: 'Hamburger ekmeği arasına coleslaw salata, köfte(260 gr), çedar sos, karamelize soğan, domates, turşu, patates kızartması ve özel soslar eşliğinde...'
  };

  return (
    isPhone ? (
      <div className="americano-detay-container">
        {/* Product Section */}
        <div className="product-section">
          <div className="product-image-container">
            <img src={yemek.image} alt={yemek.name} className="product-image" />
            <div className="product-overlay">
              <div className="product-name-price">{yemek.name} - {yemek.price}</div>
            </div>
          </div>
          
          <div className="product-description">
            <p>{yemek.description}</p>
          </div>
        </div>
      </div>
    ) : (
      <div className="urun-detay-container-computer">
        {/* Product Section */}
        <div className="product-section">
          <div className="product-image-container">
            <img src={yemek.image} alt={yemek.name} className="product-image" />
            <div className="product-overlay">
              <div className="product-name-price">{yemek.name} - {yemek.price}</div>
            </div>
          </div>
          
          <div className="product-description-computer">
            <p>{yemek.description}</p>
          </div>
        </div>
      </div>
    )
  );
};

export default CiftKofteTekLezzet;
